export const LOADER = "LOADER";
export const LOADING = "LOADING";
export const HIDING = "HIDING";

export const COUNTRIES = [
"Bahrain",	
"United Arab Emirates"	,
'Australia',	
'Afghanistan',	
'Albania',	
'Algeria',	
'American Samoa',	
'Andorra',	
'Angola',	
'Anguilla',	
'Antarctica',	
'Antigua and Barbuda',	
'Argentina',	
'Armenia',	
'Aruba',	
'Austria',	
'Azerbaijan',	
'Bahamas',	
'Bangladesh',	
'Barbados',	
'Belarus',	
'Belgium',	
'Belize',	
'Benin',	
'Bermuda',	
'Bhutan',	
'Bolivia',	
'Bonaire, Sint Eustatius and Saba',	
'Bosnia and Herzegovina',
'Botswana',	
'Bouvet Island',	
'Brazil',	
'British Indian Ocean Territory',	
'Brunei Darussalam',	
'Bulgaria',	
'Burkina Faso',	
'Burundi',	
'Cambodia',	
'Cameroon',	
'Canada',	
'Cape Verde',	
'Cayman Islands',	
'Central African Republic',	
'Chad',	
'Chile',	
'China',	
'Christmas Island',	
'Cocos Islands',	
'Colombia',	
'Comoros',	
'Congo',	
'Congo, Democratic Republic of the',	
'Cook Islands',	
'Costa Rica',	
'Croatia',	
'Cuba',	
'Curaçao',	
'Cyprus',	
'Czechia',	
'Côte d’Ivoire',	
'Denmark',	
'Djibouti',	
'Dominica',	
'Dominican Republic',	
'Ecuador',	
'Egypt',	
'El Salvador',	
'Equatorial Guinea',	
'Eritrea',	
'Estonia',	
'Eswatini',	
'Ethiopia',	
'Falkland Islands',
'Faroe Islands',	
'Fiji',	
'Finland',	
'France',	
'French Guiana',	
'French Polynesia',	
'French Southern Territories',	
'Gabon',	
'Gambia',	
'Georgia',	
'Germany',	
'Ghana',	
'Gibraltar',	
'Greece',	
'Greenland',	
'Grenada',	
'Guadeloupe',	
'Guam',	
'Guatemala',	
'Guernsey',	
'Guinea',	
'Guinea-Bissau',	
'Guyana',	
'Haiti',	
'Heard Island and McDonald Islands',	
'Holy See',	
'Honduras',	
'Hong Kong',	
'Hungary',	
'Iceland',	
'India'	,
'Indonesia'	,
'Iran',	
'Iraq',	
'Ireland',	
'Isle of Man',	
'Israel',	
'Italy',	
'Jamaica',	
'Japan',	
'Jersey',	
'Jordan',	
'Kazakhstan',	
'Kenya'	,
'Kiribati',	
'Korea, Democratic People’s Republic of',	
'Korea, Republic of',	
'Kuwait',	
'Kyrgyzstan',	
'Lao People’s Democratic Republic',	
'Latvia',	
'Lebanon',	
'Lesotho',	
'Liberia',	
'Libya',	
'Liechtenstein',	
'Lithuania',	
'Luxembourg',	
'Macao',	
'Madagascar',	
'Malawi',	
'Malaysia',	
'Maldives',	
'Mali',	
'Malta',	
'Marshall Islands',	
'Martinique',	
'Mauritania',	
'Mauritius',	
'Mayotte',	
'Mexico',	
'Micronesia',	
'Moldova',	
'Monaco',	
'Mongolia',	
'Montenegro',	
'Montserrat',	
'Morocco',	
'Mozambique',	
'Myanmar',	
'Namibia',	
'Nauru',	
'Nepal',	
'Netherlands',	
'New Caledonia',	
'New Zealand',	
'Nicaragua',	
'Niger',	
'Nigeria',	
'Niue',	
'Norfolk Island',	
'North Macedonia',	
'Northern Mariana Islands',	
'Norway',	
'Oman',	
'Pakistan',	
'Palau',	
'Palestine, State of',	
'Panama',	
'Papua New Guinea',	
'Paraguay',	
'Peru',	
'Philippines',	
'Pitcairn',	
'Poland',	
'Portugal',	
'Puerto Rico',	
'Qatar'	,
'Romania',	
'Russian Federation',	
'Rwanda',	
'Réunion',	
'Saint Barthélemy',	
'Saint Helena, Ascension and Tristan da Cunha',	
'Saint Kitts and Nevis',	
'Saint Lucia',
'Saint Martin',	
'Saint Pierre and Miquelon',	
'Saint Vincent and the Grenadines',	
'Samoa',	
'San Marino',	
'Sao Tome and Principe',	
'Saudi Arabia',	
'Senegal',	
'Serbia',	
'Seychelles',	
'Sierra Leone',	
'Singapore',	
'Sint Maarten',	
'Slovakia',	
'Slovenia',	
'Solomon Islands',	
'Somalia',	
'South Africa',	
'South Georgia and the South Sandwich Islands',	
'South Sudan',	
'Spain',	
'Sri Lanka',	
'Sudan',	
'Suriname',	
'Svalbard and Jan Mayen',	
'Sweden',	
'Switzerland',	
'Syria Arab Republic',	
'Taiwan',	
'Tajikistan',	
'Tanzania, the United Republic of',	
'Thailand',	
'Timor-Leste',	
'Togo',	
'Tokelau',	
'Tonga',	
'Trinidad and Tobago',	
'Tunisia',	
'Turkmenistan',	
'Turks and Caicos Islands',	
'Tuvalu',	
'Türkiye',	
'US Minor Outlying Islands',	
'Uganda',	
'Ukraine',	
'United Kingdom',	
'United States',	
'Uruguay',	
'Uzbekistan',	
'Vanuatu',	
'Venezuela',
'Viet Nam',	
'Virgin Islands, British',	
'Virgin Islands, U.S.',	
'Wallis and Futuna',	
'Western Sahara',	
'Yemen',	
'Zambia',	
'Zimbabwe',	
'Åland Islands'	

];


export const ID_TYPES = [
 "Passport",
  "National ID",
  "Other Government Issued ID",
];


export const SOURCE_OF_INCOME = [
'⁠Salary/Employment',
'Business Income',
'Investment Returns',
'Rental Income',
'Inheritance',
'Other'
];